<template>
	<div>
		<div class="field">
			<label v-if="label" class="label">{{ label }}</label>
			<multiselect
				:placeholder="placeholder"
				track-by="id"
				:options="filtered"
				:option-height="60"
				:disabled="!filtered.length"
				:close-on-select="false"
				@select="addUser"
			>
				<template slot="option" slot-scope="props">
					<avatar
						class="option__img"
						:image="props.option.image"
						:cropped="true"
						size="is-32x32"
					/>
					<div class="option__desc">
						<span class="option__title"
							>{{ props.option.firstname }}
							{{ props.option.lastname }}
							{{
								props.option.hospitalname
									? `&mdash; ${props.option.hospitalname}`
									: null
							}}
							<span
								v-if="props.option.status === 'invited'"
								class="tag is-info is-medium first-letter"
								>{{ props.option.status }}</span
							>
						</span>
					</div>
				</template>
			</multiselect>
		</div>

		<table class="table is-fullwidth">
			<tr v-for="(member, index) in members" :key="index">
				<td :width="40">
					<avatar
						class="option_img"
						:image="member.image"
						:cropped="true"
						size="is-32x32"
					/>
				</td>
				<td>{{ userLabel(member) }}</td>
				<td :width="80">
					<span>
						<button
							class="button is-small delete-button"
							@click.prevent="remove(member)"
						>
							Remove
						</button>
					</span>
				</td>
			</tr>
		</table>
	</div>
</template>

<script>
import fieldMixin from "@lab/utils/fieldMixin";
import fieldArrayMixin from "@lab/utils/fieldArrayMixin";

import Avatar from "@shared/components/AppAvatar";
import Multiselect from "vue-multiselect";
import { mapActions, mapGetters } from "vuex";
import { sortBy } from "lodash";

export default {
	components: {
		Avatar,
		Multiselect
	},
	mixins: [fieldMixin, fieldArrayMixin],
	props: {
		users: {
			type: Array,
			default: () => []
		},
		label: {
			type: String,
			default: () => null
		}
	},
	computed: {
		...mapGetters("hospitalsModule", ["getHospital"]),

		filtered() {
			return this.users.filter(
				(user) =>
					!this.value.filter(
						(selectedUser) => selectedUser.id === user.id
					).length
			);
		},
		hospital() {
			return this.getHospital(this.hospitalid);
		},
		hospitalid() {
			return Number(this.$route.params["id"]);
		},
		groupid() {
			return Number(this.$route.params["groupid"]);
		},
		members() {
			return sortBy(this.value, ["firstname", "lastname"]);
		},
		placeholder() {
			return this.filtered.length
				? `Select users to add this team`
				: `All existing users are members of this team`;
		}
	},
	methods: {
		...mapActions("hospitalsGroupsModule", ["removeUserFromGroup"]),
		addUser(user) {
			this.fieldPush(user);
		},
		remove({ id }) {
			// we're sorting values by first name so we need to find their actual position index
			// in the value array.
			const index = this.value.findIndex((member) => member.id === id);
			// send call to the store to remove the user from the team
			this.removeUserFromGroup({
				hospitalid: this.hospitalid,
				groupid: this.groupid,
				userid: id
			});
			// now remove the member from the field array.
			this.fieldRemove(index);
		},
		userLabel({ firstname, lastname }) {
			return `${firstname} ${lastname}`;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~vue-multiselect/dist/vue-multiselect.min.css";

.option {
	&__desc,
	&__img {
		display: inline-block;
		vertical-align: middle;
	}
	&__desc {
		margin-left: 0.5em;
	}
}
table.table {
	margin-top: 1.5rem;
	margin-bottom: 1.5rem;
	border-top: 1px solid #dbdbdb;
}
td {
	vertical-align: middle;
}
</style>
